import { App } from '@/App';
import { type PortalConfiguration } from '@/models';
import { bootstrapApp, templates, initStickyAware } from '@nosinovacao/nosid-mfe-common';
import ReactDOM from 'react-dom/client';
import './index.css';
import { auth } from './lib';
import { env } from './env';

await bootstrapApp<PortalConfiguration>('Portal');
initStickyAware();
auth.init(env.OAuthConfig, templates.clientTemplate.EnterpriseContext);
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);
